import React, { Component } from "react";
import { BrowserRouter as Router, Route, Link, Redirect, NavLink, HashRouter } from "react-router-dom";
import Header from "./../../Header";
import $ from "jquery";
import "react-infinite-calendar/styles.css"; // Make sure to import the default stylesheet
import moment from "moment";
import CryptoJS from "crypto-js";
import config from "react-global-configuration";
import Pagination from "react-js-pagination";
var datestring = moment().format("YYYY-MM");
class DevHour extends Component {
	constructor() {
		super();
		var has_local_data = localStorage.getItem("encdata") ? 1 : 0;
		var localdata = has_local_data ? this.decrypt(localStorage.getItem("encdata"), 0) : "";
		this.state = {
			enterprise: "",
			curr_month: datestring,
			str_month: [],
			searchsubscription: "",
			subscription_list: [],
			sub_search: "",
			isLoadMore: 1,
			activePage: 1,
			loading: 1,
			item_count: "",
			apiUrl: this.decryptconfigdata("apiUrl"),
			userAuthKey: has_local_data ? localdata.user_key : "",
			userId: has_local_data ? localdata.user_id : "",
			userEmail: has_local_data ? localdata.user_email : "",
			servers: [],
		};
		this.searchChange = this.searchChange.bind(this);
		this.keywordChange = this.keywordChange.bind(this);
		this.todateChange = this.todateChange.bind(this);
		this.onMonthChange = this.onMonthChange.bind(this);
		this.onEnterpriseChange = this.onEnterpriseChange.bind(this);
		this.handlePageChange = this.handlePageChange.bind(this);
	}

	decryptconfigdata(configkey) {
		var key = CryptoJS.enc.Hex.parse(config.get("enc_key"));
		var iv = CryptoJS.enc.Hex.parse(config.get("enc_iv"));
		var bytes = CryptoJS.AES.decrypt(config.get(configkey), key, {
			iv,
		});
		var plaintext = bytes.toString(CryptoJS.enc.Utf8);
		return plaintext;
	}

	decrypt(findresponse, flg) {
		var key = CryptoJS.enc.Hex.parse(config.get("enc_key"));
		var iv = CryptoJS.enc.Hex.parse(config.get("enc_iv"));
		var res = flg ? findresponse.encdata : findresponse;
		var bytes = CryptoJS.AES.decrypt(res, key, {
			iv,
		});
		var plaintext = bytes.toString(CryptoJS.enc.Utf8);
		return JSON.parse(plaintext);
	}
	rawjsonparse(findresponse, flg) {
		return findresponse;
	}

	searchChange(event) {
		document.getElementById("enterprise").value = "";
		this.setState(
			{
				enterprise: "",
				activePage: 1,
				subscription_list: [],
				loading: 1,
				searchsubscription: event.target.value,
			},
			function () {
				this.DevHourList();
			}
		);
	}

	onEnterpriseChange(event) {
		document.getElementById("searchsubscription").value = "";
		this.setState(
			{
				searchsubscription: "",
				[event.target.name]: event.target.value,
				activePage: 1,
				subscription_list: [],
				loading: 1,
			},
			function () {
				this.DevHourList();
			}
		);
	}

	todateChange(event) {
		this.setState(
			{
				activePage: 1,
				subscription_list: [],
				loading: 1,
				todate: event,
				to_date: moment(event).format("YYYY-MM-DD"),
			},
			function () {
				this.DevHourList();
			}
		);
	}

	keywordChange(event) {
		this.setState({ sub_search: event.target.value }, function () {
			//this.DevHourList();
		});
	}
	getAllServer() {
		fetch(this.state.apiUrl + "/RevenueRest/GetAllServer/userAuthKey/" + this.state.userAuthKey, {
			method: "POST",
			dataType: "json",
			body: JSON.stringify(this.state),
		})
			.then((Response) => Response.json())
			.then((findresponse) => {
				findresponse = this.rawjsonparse(findresponse, 1);
				this.setState({
					servers: findresponse.servers,
				});
			});
	}

	getSubscriptionDetails() {
		if (this.state.loading) {
			return (
				<div>
					<div class="loader-new"></div>
				</div>
			);
		} else {
			return (
				<div class="list_check">
					<div class="tickets hidden-sm">
						<ul class="tickets_head adv">
							<li class="intra_col_20">Company</li>
							<li class="intra_col_20">Customer</li>
							<li class="intra_col_20">Payment Date</li>
							<li class="intra_col_10">Dev Hours</li>
							<li class="intra_col_20">Customer Invoice</li>
							<li class="intra_col_10">Amount</li>
						</ul>
						{this.state.subscription_list.map((subscription, key) => (
							<div>
								<ul class="tickets_number">
									<li class="intra_col_20">
										{subscription.name ? (
											<Link key={key} to={`/account/${subscription.studioid}`} name={"max"}>
												{" "}
												{subscription.name}
											</Link>
										) : (
											""
										)}
									</li>
									<li class="intra_col_20">
										{subscription.first_name ? subscription.first_name : ""}
									</li>
									<li class="intra_col_20">
										{subscription.transactiondate && subscription.transactiondate != ""
											? subscription.transactiondate
											: "N/A"}
									</li>
									<li class="intra_col_10">{subscription.dev_hours}</li>
									<li class="intra_col_20">{"N/A"}</li>
									<li class="intra_col_10">{"$" + subscription.totalbill_charge}</li>
								</ul>
								<ul class="tickets_number">
									{subscription.totalbill_charges ? (
										<div>
											<li class="intra_col_20">
												{subscription.name ? (
													<Link
														key={key}
														to={`/account/${subscription.studioid}`}
														name={"max"}
													>
														{" "}
														{subscription.name}
													</Link>
												) : (
													""
												)}
											</li>
											<li class="intra_col_20">
												{subscription.first_name ? subscription.first_name : ""}
											</li>
											<li class="intra_col_20">
												{subscription.transactiondatecustom &&
													subscription.transactiondatecustom != ""
													? subscription.transactiondatecustom
													: "N/A"}
											</li>
											<li class="intra_col_10">{"N/A"}</li>
											<li class="intra_col_20">{"yes"}</li>
											<li class="intra_col_10">{"$" + subscription.totalbill_charges}</li>
										</div>
									) : (
										""
									)}
								</ul>
							</div>
						))}
					</div>
					<div class="custmer_mob hidden-md">
						{this.state.subscription_list.map((subscription, key) => (
							<div class="custmer_list_mob">
								<Link key={key} to={`/ViewDetail/${subscription.studioid}`} name={"max"}>
									<h4 class="list_title">{subscription.name}</h4>
								</Link>
								<h6>{subscription.first_name}</h6>
							</div>
						))}
					</div>
					{this.state.item_count > 0 ? (
						<div class="pagination-muvi">
							<Pagination
								itemClass={"pages"}
								itemClassFirst={"first_page"}
								itemClassPrev={"prev_page"}
								itemClassNext={"next_page"}
								itemClassLast={"last_page"}
								activePage={this.state.activePage}
								itemsCountPerPage={20}
								totalItemsCount={this.state.item_count}
								pageRangeDisplayed={5}
								onChange={this.state.setPage == "yes" ? this.handlePageChange : ""}
							/>
							<div style={{ color: "#333" }}>
								{this.state.offset + 1 + " - " + (this.state.offset + this.state.off_count)} of{" "}
								{this.state.item_count}
							</div>
						</div>
					) : (
						<div className="text-center" style={{ color: "#333" }}>
							No Data Found
						</div>
					)}
					{/* {this.loadMorecount()} */}
				</div>
			);
		}
	}

	loadMorecount() {
		if (this.state.item_count > 0) {
			if (this.state.item_count >= 20) {
				if (this.state.isLoadMore != 2) {
					if (this.state.isLoadMore == 1) {
						return (
							<div class="pagination-muvi" id="section07">
								<div class="load_more" onClick={() => this.loadMore(this.state.activePage)}>
									<span></span>
									<span></span>
									<span></span>
								</div>
							</div>
						);
					} else {
						return (
							<div class="pagination-muvi" id="section07">
								<div class="lds-ripple">
									<div></div>
									<div></div>
								</div>
							</div>
						);
					}
				}
			}
		} else {
			return <div className="text-center">No Data Found</div>;
		}
	}

	loadMore(pageNumber) {
		this.setState({ isLoadMore: 0 });
		pageNumber = pageNumber + 1;
		this.setState({ activePage: pageNumber });
		fetch(
			this.state.apiUrl +
			"/RevenueRest/DevHourList/userId/" +
			this.state.userId +
			"/userAuthKey/" +
			this.state.userAuthKey +
			"/page/" +
			pageNumber,
			{
				method: "POST",
				dataType: "json",
				body: JSON.stringify(this.state),
			}
		)
			.then((Response) => Response.json())
			.then((findresponse) => {
				findresponse = this.rawjsonparse(findresponse, 1);
				if (findresponse.subscription_list.length == 0) {
					this.setState({
						isLoadMore: 2,
					});
				} else {
					this.setState({
						isLoadMore: 1,
					});
				}
				this.setState({
					subscription_list: this.state.subscription_list.concat(findresponse.subscription_list),
				});
			});
	}

	handlePageChange(pageNumber = 1) {
		var totalPages = Math.ceil(this.state.item_count / 20);
		if (this.state.activePage != pageNumber) {
			$(document).ready(function () {
				$(".pages").addClass("disabled");
			});
			this.setState({ activePage: pageNumber, setPage: "no" });
			fetch(
				this.state.apiUrl +
				"/RevenueRest/DevHourList/page/" +
				pageNumber +
				"/userAuthKey/" +
				this.state.userAuthKey +
				"/userId/" +
				this.state.userId,
				{
					method: "POST",
					dataType: "json",
					body: JSON.stringify(this.state),
				}
			)
				.then((Response) => Response.json())
				.then((findresponse) => {
					findresponse = this.rawjsonparse(findresponse, 1);
					$(document).ready(function () {
						$(".pages").removeClass("disabled");
						if (pageNumber == 1) {
							$(".first_page").addClass("disabled");
							$(".prev_page").addClass("disabled");
						}
						if (pageNumber == totalPages) {
							$(".next_page").addClass("disabled");
							$(".last_page").addClass("disabled");
						}
					});
					this.setState({
						subscription_list: findresponse.subscription_list,
						offset: findresponse.offset,
						off_count: findresponse.off_count,
						setPage: "yes",
					});
				});
		}
	}

	DevHourList(page = 1) {
		fetch(
			this.state.apiUrl +
			"/RevenueRest/DevHourList/page/" +
			page +
			"/userAuthKey/" +
			this.state.userAuthKey +
			"/userId/" +
			this.state.userId,
			{
				method: "POST",
				dataType: "json",
				body: JSON.stringify(this.state),
			}
		)
			.then((Response) => Response.json())
			.then((findresponse) => {
				findresponse = this.rawjsonparse(findresponse, 1);
				this.setState({
					subscription_list: findresponse.subscription_list,
					item_count: findresponse.item_count,
					loading: 0,
					hidden_column: findresponse.hidden_column,
					quick_stats: findresponse.quick_stats,
					current_stats: findresponse.current_stats,
					projected_revenue: findresponse.projected_revenue,
					str_month: findresponse.str_month,
					offset: findresponse.offset,
					off_count: findresponse.off_count,
					setPage: "yes",
				});
			});
	}

	onMonthChange(event) {
		document.getElementById("enterprise").value = "";
		this.setState(
			{
				curr_month: event.target.value,
				activePage: 1,
				enterprise: "",
				subscription_list: [],
				loading: 1,
			},
			function () {
				this.DevHourList();
			}
		);
	}

	componentDidMount() {
		this.getAllServer();
		document.title = "Intranet | DevHours";
		if (!localStorage.getItem("userLogin")) {
			this.setState({ redirect: true });
		}
		this.DevHourList();
		$(".searchTicket.dept").on("click", function () {
			$(this).closest(".right-section").find(".filter_dept").slideToggle("slow");
		});
	}
	render() {
		if (this.state.redirect) {
			return <Redirect to={"/login"} />;
		}
		return (
			<div>
				<Header brecum_name="Customer" brecum_page="Customer" />
				<div class="right_col">
					<div class="intranet_body">
						<div id="exTab1" class="container">
							<div class="top-row margin_0 rev">
								<div className="left-section pull-left">
									<ul class="nav nav-pills">
										<li>
											<Link to={`/revenue`} name={"max"} class="tab">
												Subscription
											</Link>
										</li>
										<li class="active">
											<Link to={`/devhour`} name={"max"} class="tab">
												DevHours & Custom Invoice
											</Link>
										</li>
									</ul>
								</div>
								<div className="right-section">
									<div className="row">
										<div className="col-md-3 col-xs-6 filter_dept">
											<div class="searchTicket mob_customer">
												<div className="filter">
													<select
														class="form-control"
														name="enterprise"
														id="enterprise"
														onChange={this.onEnterpriseChange}
													>
														<option value="">Select Enterprise Customer</option>
														{this.state.servers.map((val, key) => (
															<option value={val.id} key={key}>
																{val.customer_name}
															</option>
														))}
														{/* {
                                             this.state.str_month.map((value, key) =>
                                             <option value={value.id}>{value.name}</option>
                                             )
                                             } */}
													</select>
													<i class="fal fa-angle-down"></i>
												</div>
											</div>
										</div>
										<div className="col-md-3 col-xs-6 filter_dept">
											<div class="searchTicket mob_customer">
												<div className="filter">
													<select
														value={this.state.curr_month}
														class="form-control"
														onChange={this.onMonthChange}
													>
														<option value="">All Months</option>
														{this.state.str_month.map((value, key) => (
															<option value={value.id}>{value.name}</option>
														))}
													</select>
													<i class="fal fa-angle-down"></i>
												</div>
											</div>
										</div>
										<div class="col-md-6 col-xs-12">
											<div class="searchTicket emp_dept">
												<input
													type="text"
													class="form-control"
													name="searchsubscription"
													id="searchsubscription"
													placeholder="Search Company"
													onChange={this.searchChange}
												/>
												<button type="submit">
													<i class="fa fa-search"></i>
												</button>
											</div>
											<div class="searchTicket filter dept hidden-md">
												<i class="fal fa-filter"></i>
											</div>
										</div>
									</div>
								</div>
							</div>
							<div class="tab-content clearfix"></div>
						</div>
						<div class="row rev">
							<div class="col-md-4 col-xs-6">
								<div class="dash_top">
									<div>
										<h6> {this.state.quick_stats ? "$ " + this.state.quick_stats : "--"}</h6>
										<span>Revenue Last Month</span>
									</div>
								</div>
							</div>
							<div class="col-md-4 col-xs-6">
								<div class="dash_top">
									<div>
										<h6> {this.state.current_stats ? "$ " + this.state.current_stats : "--"}</h6>
										<span>Revenue current Month</span>
									</div>
								</div>
							</div>
							<div class="col-md-4 col-xs-12">
								<div class="dash_top">
									<div>
										<h6>
											{this.state.projected_revenue ? "$ " + this.state.projected_revenue : "--"}
										</h6>
										<span>Project Revenue for Next Month</span>
									</div>
								</div>
							</div>
						</div>
						<div class="tab-content customer-tab clearfix">
							<div class="tab-pane active" id="Subscription">
								{this.getSubscriptionDetails()}
							</div>
						</div>
					</div>
					<div class="clearfix"></div>
				</div>
			</div>
		);
	}
}
export default DevHour;



// WEBPACK FOOTER //
// ./src/components/revenue/DevHour.js